class Toggle {
	constructor() {
		this.toggles = document.querySelectorAll('[data-toggle]');

		if (this.toggles.length > 0) {
			this.init();
		}
	}

	init() {
		this.toggles.forEach((toggle) => {
			const toggleOpenClass = toggle.getAttribute(
				'data-toggle-open-class'
			);
			const toggleButtons = toggle.querySelectorAll('[data-toggle-button]');
			const toggleContent = toggle.querySelector('[data-toggle-content]');

			if (toggleButtons.length && toggleContent) {
				toggleButtons.forEach(button => {
					if (!button.classList.contains('ei')) {
						button.addEventListener('click', (e) => {
							e.preventDefault();
							toggleContent.classList.toggle(toggleOpenClass);
						});

						button.classList.add('ei');
					}
				})

				document.addEventListener('click', (e) => {
					if (!toggle.contains(e.target)) {
						toggleContent.classList.remove(toggleOpenClass);
					}
				});
			}
		});
	}
}

export default Toggle;
